enum selectorSection {
    complaints = 0,
    returnRequests = 1,
    contractWithdrawal = 2
}

export default selectorSection;
